import script from "./CardInvoiceTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardInvoiceTable.vue?vue&type=script&setup=true&lang=ts"

import "./CardInvoiceTable.vue?vue&type=style&index=0&id=811f1d4e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-811f1d4e"]])

export default __exports__